import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { Keepalive } from '@ng-idle/keepalive';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { environment } from '../environments/environment';
import { CacheService } from './shared/services/cache.service';
import { CacheKey } from './shared/constants/cachekey.constants';
import { SSO } from './sso/sso.constants';
import { CookieService } from 'ngx-cookie-service';
import { LocalStorageService } from 'angular-2-local-storage/dist/local-storage.service';
import { CommonService } from './shared/services/common.service';
import { MessageService } from './shared/services/message.service';
import { Title } from '@angular/platform-browser';
import { MinutesSecondPipe } from './common/pipes/seconds-minutes.pipe';
import { CustomerService } from './customerservice/services/customer.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-admin',
  templateUrl: './app.component.html',
  providers: [MinutesSecondPipe]
})

export class AppComponent implements OnInit {
  idleState: number;
  timedOut = false;
  lastPing?: Date = null;
  @ViewChild('sessionTimeoutModal') public sessionTimeoutModal: ModalDirective;
  @ViewChild('retirementModal') public retirementModal : ModalDirective;
  sessionIntervalId: any;
  private _cookieService: CookieService = new CookieService(document);

  myMenuOptions = {
    menuWidth: 100
  };

  myMenuItems = [
    {
      'title': 'All Categories',
      'id': 'menuID',
      'icon': 'fa fa-reorder',
      'items': [
        {
          'name': 'User Administration',
          'id': 'itemID',
          'icon': 'fa fa-cubes',
          'link': '#',
          'items': [
            {
              'title': 'User Administration',
              'icon': 'fa fa-cubes',
              'items': [
                {
                  'name': 'Users',
                  'link': '/admin/useradministration/users'
                },
                {
                  'name': 'Roles',
                  'link': '/admin/useradministration/roles'
                }
              ]
            }
          ]
        },
        {
          'name': 'Configuration',
          'id': 'itemID',
          'icon': 'fa fa-gear',
          'link': '#',
          'items': [
            {
              'title': 'Configuration',
              'icon': 'fa fa-gear',
              'items': [
                {
                  'name': 'Business Entities',
                  'link': '/admin/configuration/businessentities'
                },
                {
                  'name': 'Countries',
                  'link': '/admin/configuration/countries'
                },
                {
                  'name': 'Currencies',
                  'link': '/admin/configuration/currencies'
                },
                {
                  'name': 'Languages',
                  'link': '/admin/configuration/languages'
                },
                {
                  'name': 'Payments',
                  'link': '/admin/configuration/paymentview/paymentmethods'
                },
                // {
                //   "name": "Payment Processors",
                //   "link": "/admin/configuration/paymentview/paymentprocessors"
                // }
              ]
            }
          ]
        },
        {
          'name': 'Store',
          'id': 'itemID',
          'icon': 'fa fa-shopping-bag',
          'link': '/admin/store/search'
        },
        {
          'name': 'Catalog',
          'id': 'itemID',
          'icon': 'fa fa-newspaper-o',
          'link': '#',
          'items': [
            {
              'title': 'Catalog',
              'icon': 'fa fa-newspaper-o',
              'items': [
                {
                  'name': 'Products',
                  'link': 'catalog/productsearch'
                },
                {
                  'name': 'Product Categories',
                  'link': 'catalog/categories'
                },
                {
                  'name': 'Product Attributes',
                  'link': 'catalog/attributes'
                },
                {
                  'name': 'Product Options',
                  'link': 'catalog/options'
                },
                {
                  'name': 'Product Tags',
                  'link': 'catalog/productTagSearch'
                },
                {
                  'name': 'Product Associations',
                  'link': 'catalog/product-associations'
                },
                {
                  'name': 'Custom Catalog',
                  'link': 'catalog/custom-catalog'
                },
                {
                  'name': 'Product Reviews',
                  'link': 'catalog/productreview'
                }
              ]
            }
          ]
        },
        {
          'name': 'Sales',
          'id': 'itemID',
          'icon': 'fa fa-line-chart',
          'link': '#'
        },
        {
          'name': 'Replicated Sites',
          'id': 'itemID',
          'icon': 'fa fa-globe',
          'link': '#'
        },
        {
          'name': 'Customers',
          'id': 'itemID',
          'icon': 'fa fa-user-secret',
          'link': '#'
        },
        // {
        //   "name": "Customer Service",
        //   "id": "itemID",
        //   "icon": "fa fa-group",
        //   "link": "#"
        // },
        {
          'name': 'Account Settings',
          'id': 'itemID',
          'icon': 'fa fa-user',
          'link': '#',
          'items': [
            {
              'title': 'Account Settings',
              'icon': 'fa fa-user',
              'items': [
                {
                  'name': 'Profile',
                  'link': '/admin/useradministration/userprofile'
                },
                {
                  'name': 'Preferences',
                  'link': '#'
                },
                {
                  'name': 'Change Password',
                  'link': '/admin/useradministration/changepassword'
                }
              ]
            }
          ]
        },
        {
          'name': 'System',
          'id': 'itemID',
          'icon': 'fa fa-desktop',
          'link': '#'
        },
        {
          'name': 'Help',
          'id': 'itemID',
          'icon': 'fa fa-question',
          'link': '#'
        },
        {
          'name': 'Customer Service',
          'id': 'itemID',
          'icon': 'fa fa-line-chart',
          'link': '/admin/customerservice/dashboard',
          'items': [
            {
              'name': 'Dashboard',
              'link': '/admin/customerservice/dashboard'
            },
            {
              'name': 'Search',
              'link': '/admin/customerservice/search'
            },
            {
              'name': 'Tickets',
              'link': '/admin/customerservice/tickets'
            },
            {
              'name': 'Knowledgebase',
              'link': '/admin/customerservice/knowledgebase'
            }
          ]
        }
      ]
    }
  ];
  isEmailWhiteList: boolean = false;
  isTermsAndCondition:boolean = false;
  csp1RetirementNoticeObj: any;

  constructor(
    private route:ActivatedRoute,
    private _cacheService: CacheService,
    private idle: Idle,
    private keepalive: Keepalive,
    private _localStorageService: LocalStorageService,
    private _commonService: CommonService,
    private _messageService: MessageService,
    private _customerService: CustomerService,
    private _titleService: Title) {
      this.setTitle();
  }

  ngOnInit(): void {
    const checkModalExist= this._cacheService.get(CacheKey.RetirementModal);
    if(!checkModalExist){
      this.checkIsPortalRetiered()
    }
    this.removeGuestToken();
    if (window.location.href.indexOf('/whitelist-email') > -1) {
      this.isEmailWhiteList = true;
      return;
    }
    if(window.location.pathname.indexOf('/anonymous-retail-subscription/terms-and-condition')>-1){
      this.isTermsAndCondition = true;
      return ;
    }
    // Idle Timeout Configurations
    this.setIdleTimeoutConfiguration(this.idle, this.keepalive);
    this.buildEditorScript();
    this.restrictBrowserPopup();
    if (!this._cacheService.get(CacheKey.COUNTRIES)) {
      this.getCountries();
    }
  }

  /**
    * To Set the title for browser tabs
  */
  setTitle(): void {
    const envName = environment && environment.envName;
    let element = document.createElement('div');
    element.innerHTML = 'CSP' + (envName ? ' &raquo; ' + envName : '');
    const title = element.innerText;
    this._titleService.setTitle(title);
  }

  restrictBrowserPopup(): void {
    const elem = this;
    $(document).on('click', 'a[href^="mailto:"]', function ($event: any) {
      elem._cacheService.set(CacheKey.IsRefreshed, true);
    });
  }

  getCountries() {
    this._customerService.getCountriesLookup().subscribe(countries => {
      if (countries && countries.length) {
        this._cacheService.set(CacheKey.COUNTRIES, countries);
      }
    });
  }
  /**
   * @description Idle timeout configuration
   * @author njagadeesan
   * @date 2019-12-10
   * @param {Idle} idle
   * @param {Keepalive} keepalive
   * @memberof AppComponent
   */
  setIdleTimeoutConfiguration(idle: Idle, keepalive: Keepalive): void {
    // sets an idle timeout
    idle.setIdle(environment.sessionLogoutInterval);
    // sets a timeout period for showing popup
    idle.setTimeout(environment.sessionPopupInterval);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      let i = this.idleState;
      this.sessionIntervalId = setInterval(() => {
        if (i === 1) {
          clearInterval(this.sessionIntervalId);
          idle.onTimeout.emit();
        }
        i--;
        this.idleState = i;
      }, 1000);
    });
    idle.onTimeout.subscribe(() => {
      this.sessionTimeoutModal.hide();
      this.timedOut = true;
      this.logout();
    });

    idle.onIdleStart.subscribe(() => {
      this.sessionTimeoutModal.show();
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = countdown;
    });

    // sets the ping interval to {{sessionPopupInterval}} seconds
    keepalive.interval(environment.sessionPopupInterval);

    keepalive.onPing.subscribe(() => this.lastPing = new Date());
    const userInfo = this._cacheService.get(CacheKey.UserInfo);
    if (userInfo) {
      idle.watch();
      this.timedOut = false;
    } else {
      idle.stop();
    }
  }
  /**
   * @description Reset the session time
   * @author njagadeesan
   * @date 2019-12-10
   * @memberof AppComponent
   */
  reset(): void {
    this.idle.watch();
    this.timedOut = false;
    clearInterval(this.sessionIntervalId);
  }
  /**
   * @description Continue working, don't logout
   * @author njagadeesan
   * @date 2019-12-10
   * @memberof AppComponent
   */
  stay(): void {
    this.sessionTimeoutModal.hide();
    this.reset();
  }

  logout(): void {
    this._cacheService.remove(CacheKey.RetirementModal);
    this._messageService.setNotifyLogoutStatus(true);
  }

  /**
   * @description  Logout the user
   * @author njagadeesan
   * @date 2019-12-10
   * @memberof AppComponent
   */
  logoutSetting(): void {
    this._cacheService.remove(CacheKey.AccessToken);
    this._cacheService.remove(CacheKey.RefreshToken);
    this._cacheService.remove(CacheKey.CountryName);
    this._cacheService.remove(CacheKey.Id_Nonce);
    this._cacheService.remove(CacheKey.Language);
    this._cacheService.remove(CacheKey.UserPermissions);
    this._cacheService.remove(CacheKey.UserInfo);
    this._cacheService.remove(CacheKey.SelectedPOSLocation);
    this._cacheService.remove(CacheKey.SelectedTerminalDetails);
    this._cacheService.remove(CacheKey.Nav_path);
    this._cacheService.remove(CacheKey.UserSearch);
    this._cacheService.remove(CacheKey.DocumentLibrary);
    this._cacheService.remove(CacheKey.StoreUserSearch);
    this._cacheService.remove(CacheKey.RoleSearch);
    this._cacheService.remove(CacheKey.StoreId);
    this._cacheService.remove(CacheKey.UserName);
    this._cacheService.remove(CacheKey.UserId);
    this._cacheService.remove(CacheKey.PaymentMethodSearch);
    this._cacheService.remove(CacheKey.PaymentProcessorSearch);
    this._cacheService.remove(CacheKey.PaymentProcessorSearch);
    this._cacheService.remove(CacheKey.Store);
    this._cacheService.remove(CacheKey.SideMenuPosition);
    this._cacheService.remove(CacheKey.CDNurlForProfileImage);
    localStorage.clear();
    this._cacheService.set(CacheKey.IsRefreshed, true);
    if (SSO.isRemoveObsoleteCookie()) {
      localStorage.removeItem(SSO.INTERNAL_ACCESS_TOKEN);
      localStorage.removeItem(SSO.INTERNAL_REFRESH_TOKEN);
      localStorage.removeItem(SSO.LOCAL_MEMBER_SESSION_ID);
      localStorage.removeItem(SSO.IS_NEW_TOKEN);
      this._cookieService.delete(SSO.INTERNAL_MEMBER_SESSIONID, environment.cookiePath, environment.cookieDomain);
    } else {
      this._cookieService.delete(SSO.INTERNAL_ACCESS_TOKEN, environment.cookiePath, environment.cookieDomain);
      this._cookieService.delete(SSO.INTERNAL_REFRESH_TOKEN, environment.cookiePath, environment.cookieDomain);
    }
    this._cookieService.delete(SSO.INTERNAL_NONCE, environment.cookiePath, environment.cookieDomain);
    this._cookieService.delete(SSO.AuthorizedUser_UAT, environment.cookiePath, environment.cookieDomain);
    this._cacheService.remove(CacheKey.RetirementModal);
    window.location.href = SSO.getSSOLogoutUrl();
  }


  @HostListener('window:beforeunload', ['$event'])
  unloadNotification() {
    const isRefreshed = this._cacheService.get(CacheKey.IsRefreshed) ? true : false;
    this._cacheService.remove(CacheKey.IsRefreshed);

    this._localStorageService.remove('departmentSearchKey');
    this._localStorageService.remove('departmentOperatingCountry');
    this._localStorageService.remove('departmentPageNumber');

    this._localStorageService.remove('ticketType');
    this._localStorageService.remove('ticketTypeOperatingCountry');
    this._localStorageService.remove('ticketTypePageNumber');

    this._localStorageService.remove('ticketSubType');
    this._localStorageService.remove('ticketSubTypeOperatingCountry');
    this._localStorageService.remove('ticketSubTypePageNumber');
    this._localStorageService.remove('ticketSubType-ticketType');

    this._localStorageService.remove('reasonsOperatingCountry');
    this._localStorageService.remove('reasonsSearch');
    this._localStorageService.remove('reasonsPageNumber');
    if(!isRefreshed){
      this._cacheService.removeSessionValue(CacheKey.SessionGuid);
    }
    return isRefreshed;
  }

  buildEditorScript(): void {
    const configScript = document.createElement('script');
    const scriptPath = environment.cdnURL + '/portals/customercare/customized-editor/ckeditor.js';
    configScript.setAttribute('src', scriptPath);
    document.head.appendChild(configScript);
  }

  removeGuestToken(){
    this._cacheService.remove(CacheKey.guestToken);
  }

  checkIsPortalRetiered() {
    this.csp1RetirementNoticeObj = environment && environment.retirementNotice ? JSON.parse(environment.retirementNotice) : null;
    setTimeout(() => {
      if (this.csp1RetirementNoticeObj && this.csp1RetirementNoticeObj.date) {
        const retirementDate = new Date(this.csp1RetirementNoticeObj.date);
        const currentDate = new Date();
        if (retirementDate <= currentDate) {
          this.retirementModal.show();
        }
      }
    }, 500);
  }

  getNoticeDescription(): string {
    if (!this.csp1RetirementNoticeObj) {
      return '';
    }
    const date = new Date(this.csp1RetirementNoticeObj.retirementDate);
    const day = date.getDate();
    const suffix = this.getOrdinalSuffix(day);
    const formattedDate = date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric'
    });
    const formattedDateWithSuffix = `<strong>${formattedDate}${suffix}</strong>`;
    return this.csp1RetirementNoticeObj.noticeDescription.replace('{date}',formattedDateWithSuffix);
  }

  getOrdinalSuffix(day: number): string {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }

  openCsp2(): void {
    this._cacheService.set(CacheKey.RetirementModal,'isModalValidated');
    this.retirementModal.hide();
    window.open(this.csp1RetirementNoticeObj.navigationUrl,'_blank');
  }

  close(){
    this._cacheService.set(CacheKey.RetirementModal,'isModalValidated');
    this.retirementModal.hide();
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts